import Button from '../Button'
import Format from '../Format'

export interface PhoneProps {
  value: string
  text?: string
  minimal?: boolean
  className?: string
  iconStart?: React.ElementType
  style?: React.CSSProperties
}

const Phone = ({ value, text, className, style, ...restProps }: PhoneProps) => (
  <Button data-qa='phone' minimal element='a' href={`tel:${value}`} className={className} style={style} {...restProps}>
    {text || <Format.Phone value={value} />}
  </Button>
)

export default Phone
